import React from 'react'
import { useNavigate } from 'react-router'
import {
  // IconMap, IconWorld, IconMapPin,
  IconCheck,
  IconDownload,
} from '@tabler/icons-react'
import Typography from '../../../atoms/Typography'
import { ROUTES } from 'src/types/routes'

interface ExportLayersMessageProps {
  onMinimize?: () => void
}

const ExportLayersMessage: React.FC<ExportLayersMessageProps> = ({ onMinimize }) => {
  const navigate = useNavigate()

  const handleUpgrade = () => {
    navigate(ROUTES.SUBS)
    if (onMinimize) {
      onMinimize()
    }
  }

  return (
    <div className="flex w-full flex-col gap-[10px] p-3">
      {/* Message Title */}
      {/* <Typography variant="sm-medium" className="whitespace-pre-wrap leading-[20px] text-[#EBF4F1]">
        I can help you export your geospatial data! Your project contains the following layers:
      </Typography> */}

      {/* Layers Summary Card */}
      {/* <div className="flex w-full flex-col gap-4 rounded-[8px] border border-[#656E75] bg-[#1B1C1E] px-6 py-4">
        <div className="flex flex-col gap-4">
          <div className="flex w-full items-start gap-3">
            <div className="flex h-6 w-6 shrink-0 items-center justify-center">
              <IconMap className="h-6 w-6 text-[#329175]" stroke={1.5} />
            </div>
            <div className="flex flex-1 flex-col gap-0">
              <Typography variant="sm-bold" className="leading-[20px] text-[#CDD1D4]">
                Project Boundaries
              </Typography>
              <Typography variant="sm" className="leading-[20px] text-[#808990]">
                <span className="font-bold text-[#329175]">Polygon layer</span>
                <span>{' • 2,450 hectares • Last updated 3 days ago'}</span>
              </Typography>
            </div>
          </div>

          <div className="flex w-full items-start gap-3">
            <div className="flex h-6 w-6 shrink-0 items-center justify-center">
              <IconWorld className="h-6 w-6 text-[#329175]" stroke={1.5} />
            </div>
            <div className="flex flex-1 flex-col gap-0">
              <Typography variant="sm-bold" className="leading-[20px] text-[#CDD1D4]">
                Vegetation Coverage
              </Typography>
              <Typography variant="sm" className="leading-[20px] text-[#808990]">
                <span className="font-bold text-[#329175]">Raster layer</span>
                <span>{' • NDVI analysis • 10m resolution'}</span>
              </Typography>
            </div>
          </div>

          <div className="flex w-full items-start gap-3">
            <div className="flex h-6 w-6 shrink-0 items-center justify-center">
              <IconMapPin className="h-6 w-6 text-[#329175]" stroke={1.5} />
            </div>
            <div className="flex flex-1 flex-col gap-0">
              <Typography variant="sm-bold" className="leading-[20px] text-[#CDD1D4]">
                Monitoring Points
              </Typography>
              <Typography variant="sm" className="leading-[20px] text-[#808990]">
                <span className="font-bold text-[#329175]">Point layer</span>
                <span>{' • 42 locations • Includes field observations'}</span>
              </Typography>
            </div>
          </div>
        </div>
      </div> */}

      {/* Export Layers Info Section */}
      <div className="flex w-full flex-col gap-4 rounded-[8px] border border-[#329175] bg-[#27292C] p-4">
        <div className="flex w-full flex-col gap-2">
          <Typography variant="lg-bold" className="leading-[28px] text-[#F5F6F6]">
            Export Layers Available
          </Typography>
          <Typography variant="sm-medium" className="leading-[20px] text-[#CDD1D4]">
            Upgrade your current plan to be able to export your layers.
          </Typography>
        </div>

        <div className="flex w-full flex-col gap-2">
          {/* Benefit items */}
          <div className="flex w-full items-center gap-2">
            <div className="flex h-4 w-4 shrink-0 items-center justify-center">
              <IconCheck className="h-4 w-4 text-[#329175]" stroke={2} />
            </div>
            <Typography variant="sm-bold" className="leading-[20px] text-[#CDD1D4]">
              Unlimited layer exports anytime
            </Typography>
          </div>

          <div className="flex w-full items-center gap-2">
            <div className="flex h-4 w-4 shrink-0 items-center justify-center">
              <IconCheck className="h-4 w-4 text-[#329175]" stroke={2} />
            </div>
            <Typography variant="sm-bold" className="leading-[20px] text-[#CDD1D4]">
              Multiple formats: Shapefile, GeoJSON, KML, GeoPackage
            </Typography>
          </div>

          <div className="flex w-full items-center gap-2">
            <div className="flex h-4 w-4 shrink-0 items-center justify-center">
              <IconCheck className="h-4 w-4 text-[#329175]" stroke={2} />
            </div>
            <Typography variant="sm-bold" className="leading-[20px] text-[#CDD1D4]">
              Batch export all layers at once
            </Typography>
          </div>

          <div className="flex w-full items-center gap-2">
            <div className="flex h-4 w-4 shrink-0 items-center justify-center">
              <IconCheck className="h-4 w-4 text-[#329175]" stroke={2} />
            </div>
            <Typography variant="sm-bold" className="leading-[20px] text-[#CDD1D4]">
              COPA-enhanced metadata & AI analysis
            </Typography>
          </div>
        </div>

        {/* Upgrade Plan Button */}
        <button
          onClick={handleUpgrade}
          className="flex h-12 w-full items-center justify-center gap-3 rounded-[100px] bg-[#329175] px-8 py-4 transition-all duration-200 hover:brightness-110"
        >
          <IconDownload className="h-5 w-5 text-[#F5F6F6]" stroke={1.5} />
          <Typography variant="base-medium" className="leading-[24px] text-[#F5F6F6]">
            Upgrade to Export Layers
          </Typography>
        </button>
      </div>
    </div>
  )
}

export default ExportLayersMessage
